import MyCustomerVue from '@/views/sm/my-customer/my-customer.vue';

const basePath = '/sm/my-customer';
const role = 'sm'; // 角色身份

export const SM_MY_CUSTOMER_INDEX = 'sm-my-customer-index';
export const SM_MY_CUSTOMER_RESERVATION_EDIT = 'sm-my-customer-reservation-edit';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: MyCustomerVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index/:userId`,
      name: SM_MY_CUSTOMER_INDEX,
      props: true,
      component: () => import(
        /* webpackChunkName: "my-customer-index" */
        `@/views/${role}/my-customer/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/edit/:id`,
      name: SM_MY_CUSTOMER_RESERVATION_EDIT,
      props: true,
      component: () => import(
        /* webpackChunkName: "my-customer-reservation-edit" */
        `@/views/${role}/my-customer/edit.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
